module.exports = __webpack_public_path__ + "icon-breadcrumb.svg?e7e804a7cfcf59e606f3b6b685b8b0f1";